import { useQuery } from "react-query";

import productLineService from "../../../services/api/productLine";
import { IParams } from "../../../services/api/types";
import { TenantCode } from "../../../models/brand";

import {
  RequestFormatter,
  TextRequestFormatter,
} from "../../../services/request-formatter";

const getProductLineParams = (tenantCode: TenantCode) => {
  const query = new RequestFormatter([
    new TextRequestFormatter({
      field: "tenant_code",
      value: tenantCode,
    }),
  ]).toString();

  return {
    q: query,
  };
};

function fetchProductLineList(key: string, params: IParams) {
  return productLineService.getAll(params);
}

export function useProductLineListQuery(tenantCode: TenantCode) {
  return useQuery(
    Boolean(tenantCode) && [
      "productLineList",
      getProductLineParams(tenantCode),
    ],
    fetchProductLineList,
  );
}
